import { Fragment, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import Header from "../component/layout/header";
import Footer from "../component/layout/footer";
import PageHeader from "../component/layout/pageheader";
import SearchBar from "../component/sidebar/search";
import Categorie from "../component/sidebar/categorie";

import { ShopContext } from "../context/ShopContext";

const ShopDetails = () => {
  const { productId } = useParams();
  const { products, currency, addToCart } = useContext(ShopContext);

  const [product, setProduct] = useState(null);
  const [activeImage, setActiveImage] = useState("");
  const [size, setSize] = useState("");

  useEffect(() => {
    if (products.length > 0) {
      const found = products.find((p) => p._id === productId);
      if (found) {
        setProduct(found);
        setActiveImage(found.image?.[0]);
      }
    }
  }, [products, productId]);

  if (!product) {
    return <div className="text-center py-20">Loading product...</div>;
  }

  return (
    <Fragment>
      <Header />
      <PageHeader title={product.name} curPage="Shop Details" />

      <div className="shop-single modern-shop-details padding-top padding-bottom ">
        <div className="container">
  
            {/* ================= PRODUCT ================= */}
            <div className="col-lg-9 col-md-8 col-12">
              <div className="product-layout">

                {/* THUMBNAILS */}
                <div className="product-thumbs">
                  {product.image.map((img, i) => (
                    <img
                      key={i}
                      src={img}
                      alt={product.name}
                      className={activeImage === img ? "active" : ""}
                      onClick={() => setActiveImage(img)}
                    />
                  ))}
                </div>

                {/* MAIN IMAGE */}
                <div className="product-main-image">
                  <img src={activeImage} alt={product.name} />
                </div>

                {/* INFO */}
                <div className="product-info-panel">
                  <h2 className="product-title">{product.name}</h2>
                  <h3 className="product-price">
                    {currency}{product.price}
                  </h3>

                  <p className="product-desc">{product.description}</p>

                  {/* SIZE BUTTONS */}
                  {product.sizes?.length > 0 && (
                    <div className="size-section">
                      <p>Select Size</p>
                      <div className="size-buttons">
                        {product.sizes.map((s, i) => (
                          <button
                            key={i}
                            className={size === s ? "active" : ""}
                            onClick={() => setSize(s)}
                          >
                            {s}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}

                  <button
                    className="default-button mt-4"
                    onClick={() => addToCart(product._id, size)}
                  >
                    <span>Add To Cart</span>
                  </button>

                  <ul className="product-notes">
                    <li>100% Original product</li>
                    <li>Cash on delivery available</li>
                    
                  </ul>
                </div>

              </div>
            </div>

        </div>
      </div>

      <Footer />
    </Fragment>
  );
};

export default ShopDetails;
